import { connect } from "react-redux";

import FormPlan from "./Component";

const mapDispatchToProps = () => ({});

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FormPlan);
